import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom'; 
import { HashLink } from 'react-router-hash-link';

import "./Navbar.css";

export default function Navigations() {
  return (
    <Navbar expand="lg">
      <Container>
        <Navbar.Brand href="#home">POOL GUY</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <HashLink to="/#home">Home</HashLink>
            <HashLink to="/#serviec">Service</HashLink>
            <Link to="/about">About</Link>
            <HashLink to="/#faq">FAQ</HashLink>
            <HashLink to="/#contact">Contact</HashLink>
          </Nav>
          <Nav>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
